module.exports = __webpack_public_path__ + "img/qc.10ab71fa.png";